var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-parallax',{class:_vm.classes,attrs:{"height":_vm.height,"src":_vm.src}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }